module.exports = __webpack_public_path__ + "static/img/20006 (4).966e969.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20006 (4).webp
// module id = oZZQ
// module chunks = 14